export default __webpack_public_path__ + "static/media/arrowUp.2f9df1b2.svg";